/* eslint-disable @ngrx/avoid-dispatching-multiple-actions-sequentially */
import { AsyncPipe, Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ShippingAddress } from '@api/model/shippingAddress';
import * as CheckoutActions from '@store/checkout/checkout.actions';
import { selectIsLoadingShippingOptions, selectIsShippingDeliveryDetailsRequired } from '@store/checkout/checkout.selectors';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { Observable, take } from 'rxjs';
import { RouterService } from '@core/services/router.service';
import { selectUserProfileAddresses, selectUserProfileDefaultShippingAddressRef } from '@store/user/user.selectors';
import { UntilDestroy } from '@core/classes/untilDestroy.class';
import { TranslateModule } from '@ngx-translate/core';
import { AddressEditComponent } from '../../../../../core/components/address-edit/address-edit.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { LetDirective } from '@ngrx/component';
import { UserActions } from '@store/user/user.actions';
import { SNAME } from '@core/constants/storage';
import {LoadingOverlayComponent} from '@core/components/loading-overlay/loading-overlay.component';
import {NoticeBannerComponent} from '@core/components/notice-banner/notice-banner.component';
import {ShippingOptionError, ShippingOptionErrorCode} from '@store/checkout/checkout.interface';

@Component({
  selector: 'pbb-edit-address-page',
  templateUrl: './edit-address-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LetDirective, MatButtonModule, RouterLink, MatIconModule, AddressEditComponent, TranslateModule, LoadingOverlayComponent, AsyncPipe, NoticeBannerComponent],
})
export class EditAddressPageComponent extends UntilDestroy implements OnInit {
  addresses$: Observable<Array<ShippingAddress>> = this.store.select(selectUserProfileAddresses);
  defaultShippingAddressRef$: Observable<string> = this.store.select(selectUserProfileDefaultShippingAddressRef);
  isShippingDeliveryDetailsRequired$: Observable<boolean> = this.store.select(selectIsShippingDeliveryDetailsRequired);
  address!: ShippingAddress;
  isMerchantAddress: boolean = false;
  isLoading: boolean = false;
  continueToShipping: boolean = false;
  pendingShippingAddress?: ShippingAddress;
  routeData$: Observable<any> = this.routerService.routeData;
  isLoadingShippingAddress$ =  this.store.select(selectIsLoadingShippingOptions);
  shippingOptionsError: ShippingOptionError | null = null;
  ShippingOptionErrorCode = ShippingOptionErrorCode;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly store: Store,
    private readonly actions$: Actions<any>,
    private location: Location,
    private routerService: RouterService
  ) {
    super();
  }

  ngOnInit(): void {
    const historyState = window.history.state as any;
    const merchantAddress = historyState?.merchantAddress;
    this.continueToShipping = !!historyState?.continueToShipping;
    const state = history.state as any;

    if(state?.shippingOptionsError) {
      this.shippingOptionsError = state.shippingOptionsError;
    }

    if (state?.selectedAddress) {
      this.isMerchantAddress = true;
      this.address = {
        ...state.selectedAddress,
        street_name: `${[state.selectedAddress?.street_number, state.selectedAddress?.street_name].join(' ').trim()}`,
        street_number: ' ',
        shipping_address_ref: state.selectedAddress?.shipping_address_ref? state.selectedAddress.shipping_address_ref : undefined,
      };
    }
  }

  saveShippingAddress(shippingAddress: ShippingAddress) {
    this.isLoading = true;
    this.store.dispatch(UserActions.modifyShippingAddressList());

    shippingAddress.postal_code = shippingAddress.postal_code.toUpperCase();
    this.pendingShippingAddress = shippingAddress;

    console.log('Saving shipping address:', shippingAddress);

    this.isShippingDeliveryDetailsRequired$.pipe(take(1)).subscribe((isShippingDeliveryDetailsRequired) => {
      if(!isShippingDeliveryDetailsRequired) {

        if (shippingAddress.shipping_address_ref) {
          this.store.dispatch(UserActions.updateShippingAddressStart({ shippingAddress }));
        } else {
          this.store.dispatch(UserActions.addShippingAddressStart({ shippingAddress }));
        }
        this.location.back();
      } else {
        this.store.dispatch(CheckoutActions.saveAddressAndFetchOptions({ shippingAddress }));
      }
    });

    
  }

  // private continueCheckoutFlow(shippingAddress: ShippingAddress): void {
  //   this.store
  //     .select(selectIsShippingDeliveryDetailsRequired)
  //     .pipe(take(1))
  //     .subscribe((isShippingDeliveryDetailsRequired) => {
  //       if (isShippingDeliveryDetailsRequired) {
  //         this.router.navigate(['/checkout/select-shipping-address']);
  //         this.store.dispatch(
  //           CheckoutActions.selectShippingAddressAndFetchOptions({
  //             shippingAddress,
  //           })
  //         );
  //         return;
  //       }

  //       this.store.dispatch(
  //         CheckoutActions.selectShippingAddressWithPostalCode({
  //           addressRef: shippingAddress.shipping_address_ref || '',
  //           postalCode: shippingAddress.postal_code || '',
  //         })
  //       );
  //       sessionStorage.setItem(SNAME.SET_DEVICE_VISITED, 'true');
  //       this.router.navigate(['/checkout/registered/orderReview']);
  //     });
  // }

  // private isSameAddress(left: ShippingAddress, right: ShippingAddress): boolean {
  //   return (
  //     (left.recipient_name || '') === (right.recipient_name || '') &&
  //     (left.street_name || '') === (right.street_name || '') &&
  //     (left.apartment || '') === (right.apartment || '') &&
  //     (left.city || '') === (right.city || '') &&
  //     (left.province || '') === (right.province || '') &&
  //     (left.postal_code || '').toUpperCase() === (right.postal_code || '').toUpperCase()
  //   );
  // }
}
